/**
 * TODO (russell): This component is not yet a collage. Right now it's just a
 * wrapper around a static image.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

const EqualizeAccessCollage = (): React.ReactElement<
    React.ComponentProps<"img">
> => {
    return (
        <img
            alt=""
            className={css(styles.img)}
            src={staticUrl("/images/lohp/equalize-access@2x.jpg")}
        />
    );
};

const styles = StyleSheet.create({
    img: {
        margin: "auto",

        [mediaQueries.smOrSmaller]: {
            width: "100%",
            transform: "scale(1.2)",
        },
        [mediaQueries.md]: {
            width: "85%",
        },
        [mediaQueries.lgOrLarger]: {
            margin: "initial",
            width: "116%",
        },
    },
});

export default EqualizeAccessCollage;
